import { keys } from 'lodash-es';
import { v4 as uuid } from 'uuid';

import { rippleStyles } from '../constants/ripple-styles.const';
import { RippleState } from '../enums/ripple-directive.enums';

export class Ripple {
  readonly id: string;

  readonly element: HTMLDivElement;

  state: RippleState = RippleState.FadingIn;

  constructor(
    private readonly offsetX: number,
    private readonly offsetY: number,
    private readonly radius: number,
    private readonly enterDuration: number,
  ) {
    this.id = uuid();
    this.element = this.composeRipple();
  }

  private composeRipple(): HTMLDivElement {
    const ripple = document.createElement('div');

    ripple.setAttribute('id', ripple.id);
    ripple.setAttribute('data-testid', 'ripple');

    keys(rippleStyles).forEach((style) => {
      ripple.style[style] = rippleStyles[style] as string;
    });

    ripple.style.transitionDuration = `${this.enterDuration}ms`;
    ripple.style.left = `${this.offsetX - this.radius}px`;
    ripple.style.top = `${this.offsetY - this.radius}px`;
    ripple.style.height = `${this.radius * 2}px`;
    ripple.style.width = `${this.radius * 2}px`;

    return ripple;
  }
}
